import "./IconAdd.scss";
import { ReactComponent as AddIcon } from "./svg/add.svg";

type Props = {
  color?: "black" | "blue";
};

export const IconAdd = (props: Props) => {
  const { color = "black" } = props;
  return (
    <span className={`IconAdd IconAdd__${color}`}>
      <AddIcon />
    </span>
  );
};
